<template>
  <div>
    <el-card shadow="always">
      <el-page-header v-if="id === ''" @back="back" title :content="$t('adicionar-novo-grupo-servico')"></el-page-header>
      <el-page-header v-if="id !== ''" @back="back" title :content="$t('atualizar-grupo-servico')"></el-page-header>
    </el-card>
    <el-card>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top">
        <el-row :gutter="5">
          <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
            <el-form-item :label="$t('codigo')" prop="code">
              <el-input ref="code" :disabled="id !== ''" v-model="ruleForm.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="16" :lg="15" :xl="15">
            <el-form-item :label="$t('nome')" prop="name">
              <el-input ref="name" v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
            <el-form-item :label="$t('simbolo')" prop="symbol">
              <el-select ref="symbol" v-model="ruleForm.symbol">
                <el-option :key="1" label="Premium" :value="1"> </el-option>
                <el-option :key="2" label="Expressa" :value="2"> </el-option>
                <el-option :key="3" label="Padrão" :value="3"> </el-option>
                <el-option :key="4" label="Mini Envios" :value="4">
                </el-option>
                <el-option :key="5" label="Sem especificação" :value="5">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="16" :lg="15" :xl="15">
            <el-form-item :label="$t('nome')" prop="name">
              <el-input ref="name" v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <br />
        <el-row :gutter="5">
          <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
            <el-checkbox ref="checkcouriers" v-model="ruleForm.checkcouriers">{{
              $t("disponibilidade-correios")
            }}</el-checkbox>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
            <el-checkbox ref="plp" v-model="ruleForm.plp">{{
              $t("utiliza-plp")
            }}</el-checkbox>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
            <el-checkbox ref="plp" v-model="ruleForm.reverse">{{
              $t("logistica-reversa")
            }}</el-checkbox>
          </el-col>
        </el-row>
        <el-form-item :label="$t('logo')" prop="name">
          <el-upload class="avatar-uploader" action="/api/services/upload" :show-file-list="false" :auto-upload="false"
            :on-change="changeFile">
            <img v-if="imageUrl" :src="imageUrl" class="image-service" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <br />
        <el-form-item style="text-align: center">
          <el-button type="warning" v-if="id === ''" autofocus @click="submitForm('ruleForm')">{{ $t("adicionar")
          }}</el-button>
          <el-button type="warning" v-if="id !== ''" autofocus @click="editForm('ruleForm')">{{ $t("atualizar")
          }}</el-button>
          <el-button @click="back()">{{ $t("voltar") }}</el-button>
        </el-form-item>
        <br />
        <el-tabs v-model="activeTab" type="border-card">
          <el-tab-pane :lazy="true" :label="$t('servicos')" name="tabservices">
            <el-table :data="tableServices" stripe ref="tableServices" style="width: 100%"
              :default-sort="{ prop: 'name', order: 'ascending' }">
              <el-table-column type="selection" width="180"></el-table-column>
              <el-table-column sortable prop="code" :label="$t('codigo')"></el-table-column>
              <el-table-column sortable prop="name" :label="$t('nome')"></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { i18n } from "@/plugin/i18n";
import { ServicesGroupService } from "@/services/customers/services.group.services";
import { ServicesService } from "@/services/customers/services.services";

export default {
  name: "ServiceAdd",
  data() {
    return {
      id: "",
      imageUrl: "",
      tableServices: [],
      activeTab: "tabservices",
      ruleForm: {
        token: "",
        name: "",
        code: "",
        symbol: 3,
        reverse: false,
        checkcouriers: true,
        plp: true,
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: i18n.tc("codigo-obrigatorio"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.replace({ name: "services.group" });
    },
    fetchServices() {
      var vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      ServicesService.list()
        .then((response) => {
          vm.tableServices = response.records;
          vm.get();
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    get() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      ServicesGroupService.get(vm.id)
        .then((response) => {
          vm.ruleForm = response;
          if (response.file) {
            vm.imageUrl = response.file.url;
          }
          if (response.service) {
            for (const record of response.service) {
              for (const row of vm.tableServices) {
                if (row.id === record.id) {
                  vm.$refs.tableServices.toggleRowSelection(row);
                }
              }
            }
          }
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          ServicesGroupService.add(
            vm.ruleForm,
            vm.$refs.tableServices.selection
          )
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("grupo-servico-adicionado-sucesso"),
              });
              this.$refs[formName].resetFields();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    changeFile(file, fileList) {
      var vm = this;
      ServicesService.upload(file)
        .then((response) => {
          vm.ruleForm.token = response.token;
          vm.imageUrl = response.content;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          ServicesGroupService.update(
            vm.id,
            vm.ruleForm,
            vm.$refs.tableServices.selection
          )
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("grupo-servico-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    vm.fetchServices();
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
    } else {
      vm.$refs.code.$el.children[0].focus();
    }
  },
};
</script>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 208px;
  height: 120px;
  line-height: 178px;
  text-align: center;
}

.image-service {
  width: 208px;
  height: 120px;
  display: block;
}
</style>
